/**
 * Bottom-right "Remove from cart" confirmation. Wired from component-cart-items.js
 * via window.fabelleConfirmCartLineRemove(component, line, onConfirm).
 *
 * Uses a native <dialog> + showModal() so the overlay appears above the cart drawer
 * (also a dialog). Plain divs with z-index sit below the browser top layer.
 */
(function () {
  var root;
  var lastFocus;
  var onConfirmCallback;

  function getRoot() {
    if (root) return root;
    root = document.createElement('dialog');
    root.id = 'fabelle-cart-remove-modal';
    root.className = 'fabelle-crm-dialog';
    root.setAttribute('aria-labelledby', 'fabelle-crm-title');
    root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<div class="fabelle-crm__scrim" data-fabelle-crm-close aria-hidden="true"></div>' +
      '<div class="fabelle-crm__panel" tabindex="-1">' +
      '<button type="button" class="fabelle-crm__x" data-fabelle-crm-close aria-label="Close">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<g clip-path="url(#fabelle-crm-close-clip)">' +
      '<path d="M18.75 5.25L5.25 18.75" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '<path d="M18.75 18.75L5.25 5.25" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</g>' +
      '<defs>' +
      '<clipPath id="fabelle-crm-close-clip">' +
      '<rect width="24" height="24" fill="white"></rect>' +
      '</clipPath>' +
      '</defs>' +
      '</svg>' +
      '</button>' +
      '<div class="fabelle-crm__row">' +
      '<div class="fabelle-crm__media" id="fabelle-crm-media"><img id="fabelle-crm-img" alt=""/></div>' +
      '<div class="fabelle-crm__text"><h2 id="fabelle-crm-title">Remove from Cart</h2><p>Are you sure you want to remove this product from cart?</p></div>' +
      '</div>' +
      '<div class="fabelle-crm__actions">' +
      '<button type="button" class="fabelle-crm__btn fabelle-crm__btn--remove" data-fabelle-crm-confirm>REMOVE FROM CART</button>' +
      // '<button type="button" class="fabelle-crm__btn fabelle-crm__btn--wishlist" data-fabelle-crm-close>MOVE TO WISHLIST</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(root);

    /* Any code path that closes the dialog must clear the body lock */
    root.addEventListener('close', function () {
      document.body.classList.remove('fabelle-crm--open');
    });
    root.addEventListener('cancel', function (e) {
      e.preventDefault();
      dismissModal(false);
    });
    root.addEventListener('click', function (e) {
      if (e.target === root) {
        e.preventDefault();
        dismissModal(false);
        return;
      }
      /* Text node / non-Element targets have no .closest — confirm was never found */
      var t = e.target;
      var el = null;
      if (t instanceof Element) {
        el = t;
      } else if (t instanceof Node && t.parentElement) {
        el = t.parentElement;
      }
      if (!el || typeof el.closest !== 'function') {
        return;
      }
      if (el.closest('[data-fabelle-crm-confirm]')) {
        e.preventDefault();
        dismissModal(true);
        return;
      }
      if (el.closest('[data-fabelle-crm-close]')) {
        e.preventDefault();
        dismissModal(false);
      }
    });

    return root;
  }

  var dismissing = false;
  function dismissModal(confirmed) {
    if (dismissing) {
      return;
    }
    dismissing = true;
    try {
      var r = getRoot();
      var cb = onConfirmCallback;
      onConfirmCallback = null;
      var focusTarget = lastFocus;
      lastFocus = null;
      if (r.open) {
        r.close();
      }
      document.body.classList.remove('fabelle-crm--open');
      if (confirmed && typeof cb === 'function') {
        /* Sync: close dialog first, then remove so cart is not inert; no refocus to trash before remove */
        try {
          cb();
        } catch (err) {
          console.error(err);
        }
      } else if (!confirmed && focusTarget && typeof focusTarget.focus === 'function') {
        try {
          focusTarget.focus();
        } catch (e) {
          /* ignore */
        }
      }
    } finally {
      dismissing = false;
    }
  }

  function forceCloseRemoveModal() {
    onConfirmCallback = null;
    lastFocus = null;
    var r = document.getElementById('fabelle-cart-remove-modal');
    if (r && r.open) {
      r.close();
    }
    document.body.classList.remove('fabelle-crm--open');
  }

  window.addEventListener('pagehide', forceCloseRemoveModal);

  function fabelleConfirmCartLineRemove(component, line, onConfirm) {
    if (typeof onConfirm !== 'function') {
      return;
    }
    if (!component || !component.refs) {
      onConfirm();
      return;
    }
    var rows = component.refs.cartItemRows;
    var row = rows && rows[line - 1];
    if (!row) {
      onConfirm();
      return;
    }

    lastFocus = document.activeElement;
    onConfirmCallback = onConfirm;
    var r = getRoot();
    var imgEl = document.getElementById('fabelle-crm-img');
    var media = document.getElementById('fabelle-crm-media');
    var srcImg = row.querySelector('.cart-items__media-image') || row.querySelector('img');
    if (imgEl) {
      if (srcImg) {
        var s = (srcImg.currentSrc || srcImg.getAttribute('src') || srcImg.src || '').toString().trim();
        if (s) {
          imgEl.src = s;
          imgEl.alt = (srcImg.getAttribute('alt') || 'Product') + '';
          if (media) media.classList.remove('is-empty');
        } else {
          imgEl.removeAttribute('src');
          if (media) media.classList.add('is-empty');
        }
      } else {
        imgEl.removeAttribute('src');
        if (media) media.classList.add('is-empty');
      }
    } else if (media) {
      media.classList.add('is-empty');
    }

    try {
      r.showModal();
    } catch (err) {
      /* Already open (should not happen) or unsupported */
      onConfirm();
      onConfirmCallback = null;
      lastFocus = null;
      return;
    }
    document.body.classList.add('fabelle-crm--open');
    var panel = r.querySelector('.fabelle-crm__panel');
    if (panel) {
      panel.focus();
    }
  }

  window.fabelleConfirmCartLineRemove = fabelleConfirmCartLineRemove;
})();
